/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PseudonymAppointmentsAliases {
  BREADCRUMB = 'breadcrumb',
  FRAGMENT_REFERENCE_ADDITIONAL_INFORMATION = 'fragment-reference-additional-information',
  FRAGMENT_REFERENCE_ANALYTICS = 'fragment-reference-analytics',
  FRAGMENT_REFERENCE_CHECKUP_SCHEDULE_PERIOD = 'fragment-reference-checkup-schedule-period',
  FRAGMENT_REFERENCE_CHECKUP_SUGGESTION = 'fragment-reference-checkup-suggestion',
  FRAGMENT_REFERENCE_CHOOSE_PATIENT = 'fragment-reference-choose-patient',
  FRAGMENT_REFERENCE_DOCUMENTS = 'fragment-reference-documents',
  FRAGMENT_REFERENCE_LOCATION = 'fragment-reference-location',
  FRAGMENT_REFERENCE_QUIZ = 'fragment-reference-quiz',
  FRAGMENT_REFERENCE_SCHEDULE_PERIOD = 'fragment-reference-schedule-period',
  FRAGMENT_REFERENCE_SCHEDULING_ITEMS = 'fragment-reference-scheduling-items',
  FRAGMENT_REFERENCE_SUGGESTION = 'fragment-reference-suggestion',
  FRAGMENT_REFERENCE_SUMMARY = 'fragment-reference-summary',
  LAYOUT_APPOINTMENTS = 'layout-appointments',
  WIZARD_APPOINTMENTS = 'wizard-appointments',
  WIZARD_STEP_ADDITIONAL_INFORMATION = 'wizard-step-additional-information',
  WIZARD_STEP_CHECKUP_SCHEDULE_PERIOD = 'wizard-step-checkup-schedule-period',
  WIZARD_STEP_CHECKUP_SUGGESTIONS = 'wizard-step-checkup-suggestions',
  WIZARD_STEP_CHOOSE_PATIENT = 'wizard-step-choose-patient',
  WIZARD_STEP_LOCATION = 'wizard-step-location',
  WIZARD_STEP_QUIZ = 'wizard-step-quiz',
  WIZARD_STEP_SCHEDULE_PERIOD = 'wizard-step-schedule-period',
  WIZARD_STEP_SCHEDULING_ITEMS = 'wizard-step-scheduling-items',
  WIZARD_STEP_SUGGESTION = 'wizard-step-suggestion',
  WIZARD_STEP_SUMMARY = 'wizard-step-summary',
  WIZARD_STEP_UPLOAD_DOCUMENTS = 'wizard-step-upload-documents',
}
export { PseudonymAppointmentsAliases };
